const conf = {
  user: {
    name: process.env.REACT_APP_USER_NAME ||
      (process.env.NODE_ENV==='development' ? 'Dev' : 'Prod'),
    email: process.env.REACT_APP_USER_EMAIL ||
      (process.env.NODE_ENV==='development' ? 'dev@aa.aa' : 'dev@aa.aa'),
  },

  api: {
    url: process.env.REACT_APP_API_URL || 'http://127.0.0.1:5055/v1',
  },

  // interestForm: {
  //   url: process.env.REACT_APP_INTEREST_FORM_URL || '',
  // },
}
console.log('conf.api.url:', conf.api.url)

export default conf
